export var TeamMemberSkill;
(function (TeamMemberSkill) {
    TeamMemberSkill["Bridging"] = "Bridging";
    TeamMemberSkill["ComplexInvestments"] = "Complex Investments";
    TeamMemberSkill["Construction"] = "Construction";
    TeamMemberSkill["DebtConsolidation"] = "Debt Consolidation";
    TeamMemberSkill["ExistingCustomer"] = "Existing Customer";
    TeamMemberSkill["Guarantor"] = "Guarantor";
    TeamMemberSkill["HighValue"] = "High Value";
    TeamMemberSkill["LoanSizeLessThan200k"] = "Loan Size < 200k";
    TeamMemberSkill["LowDoc"] = "Low Doc";
    TeamMemberSkill["NonConformingLending"] = "Non-conforming lending";
    TeamMemberSkill["PAYG"] = "PAYG";
    TeamMemberSkill["SelfEmployedPtyLtd"] = "Self Employed PTY LTD";
    TeamMemberSkill["SelfEmployedSoleTrader"] = "Self Employed sole trader";
    TeamMemberSkill["Trust"] = "Trust";
    TeamMemberSkill["SlrToHls"] = "SLR to HLS";
    TeamMemberSkill["VideoAppointment"] = "Video Appointment";
})(TeamMemberSkill || (TeamMemberSkill = {}));
//# sourceMappingURL=TeamMemberSkill.js.map